<template>
    <Head title="Applicant Training"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <Button
                            label="Input Test Selection"
                            icon="pi pi-envelope"
                            class="p-button-primary mr-2"
                            @click="showNewDialog"
                        />
                    </template>
                    <template v-slot:end>
                        <Button
                                label="Print Selected Candidate"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                @click="exportDetail"
                                :loading="isExporting"
                                :disabled="
                                    !selectedModels || !selectedModels.length || selectedModels.length > 1
                                "
                            />
                    </template>
                </Toolbar>
                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Manage Applicant Training</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="searchFilter"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                    ></Column>
                    <Column
                        field="id"
                        header="ID"
                        :sortable="true"
                        headerStyle="width:1%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Id</span>
                            {{ slotProps.data.id }}
                        </template>
                    </Column>
                    <Column
                        field="name"
                        header="Name"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Name</span>
                            {{ slotProps.data.name }}
                        </template>
                    </Column>
                    <Column
                        field='evaluation_date'
                        header="Evaluation Date"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Evaluation Date</span>
                            {{ slotProps.data.evaluation_date }}
                        </template>
                    </Column>
                    <Column
                        field="score"
                        header="Score"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            {{ slotProps.data.score }}
                        </template>
                    </Column>
                    <Column
                        field="is_passed"
                        header="Passed"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span :class="'applicant-badge status-' + slotProps.data.is_passed">{{ slotProps.data.is_passed }}</span>
                        </template>
                    </Column>
                    <Column>
                        <template #body="slotProps">
                            <Button
                                label="Detail"
                                icon="pi pi-eye"
                                class="mr-2"
                                @click="showDetail(slotProps.data.id)"
                            />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../../Layouts/AppLayout";
import { FilterMatchMode } from "primevue/api";
import { Head } from "@inertiajs/inertia-vue3";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import DatatableService from "../../../Services/DatatableService";
import { Inertia } from "@inertiajs/inertia";
import axios from "axios";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        Head,
        Button,
        InputText,
        Toolbar,
        Toast,
        DataTable,
        Column,
        Dropdown,
        Dialog,
    },
    data() {
        return {
            searchFilter: "",
            filters: {},
            lazyParams: {},
            loading: true,
            totalRecords: 0,
            selectedModel: null,
            model: {},
            models: null,
            selectedModels: null,
            submitted: false,
            selectAll: false,
            isExporting: false,
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
        this.initFilters();
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };

        if(localStorage.getItem('lazyParams')){
            this.lazyParams = JSON.parse(localStorage.getItem('lazyParams'));
            this.searchFilter = this.lazyParams.filters.global.value;
        }

        this.loadLazyData();
    },
    methods: {
        showDetail(id){
            this.$inertia.get(`${this.$page.props.appUrl}candidate-trainings/${id}`);
        },
        showNewDialog(){
            this.$inertia.get(`${this.$page.props.appUrl}candidate-trainings/create`);
        },
        exportDetail(){
            this.isExporting = true;
            const rawObject = {...this.selectedModels[0]};
            axios({
                method: 'get',
                url: this.$page.props.appUrl + `api/applicant-trainings/${rawObject.id}/export`,
                responseType: 'blob'
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Candidate-Training.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        loadLazyData() {
            this.loading = true;
            this.datatableService
                .getData(`${this.$page.props.appUrl}api/applicant-trainings/datatable`, this.lazyParams)
                .then((data) => {
                    this.models = data.data;
                    this.totalRecords = data.total;
                    this.loading = false;
                });
        },
        convertDate(str) {
            /** Script From https://stackoverflow.com/a/6292335 */
            var date = new Date(str),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
            return [date.getFullYear(), mnth, day].join("-");
        },
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        onPage(event) {
            this.lazyParams.first = event.first;
            this.lazyParams.page = event.page;
            this.lazyParams.pageCount = event.pageCount;
            this.lazyParams.rows = event.rows;
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams.sortField = event.sortField;
            this.lazyParams.sortOrder = event.sortOrder;
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        onFilter(event) {
            this.lazyParams.filters['global'] = { field: 'applicant.name', value: this.searchFilter };
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS, field: 'id' },
            };
        },
    },
};
</script>
<style scoped lang="scss">
@import "../../../../assets/demo/badges.scss";
</style>
